
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';
import {UserLogEntryHelper} from "@/models/userlog/user.log.entry.helper";

/**
 *
 * @class CanParkBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2021
 *
 */
export class CanParkBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:      string = data._id.match(/^can-park-(.*)/i)[1];
    let proposed:    any = null;

    if (data.pr) {

      let before: any    = null;
      let after: any     = null;

      if (data.pr.a != null) {

        after = {
          name:    data.pr.a.d,
          mileage: data.pr.a.m
        };
      }

      if (data.pr.b != null) {

        before = {
          name:    data.pr.b.d,
          mileage: data.pr.b.m
        };
      }

      proposed = {
        id:      data.pr.i,
        track:   data.pr.t,
        mileage: data.pr.m,
        before,
        after
      };
    }

    const pr: string     = UserLogEntryHelper.trackString(data.pr);

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name:            `Can Park: ${pr}`,
      hasChildren:     args.hasChildren,
      isExpanded:      args.isExpanded,
      type:            'can-park',
      children:        args.children,
      parent:          args.parent,
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      proposed,
      u:               data._id
    };

  }
}
